
class DashboardTestHarness{
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || 'dashboard-test-harness.html'
    }
}

angular.module('emun.shopping.admin').component('dashboardTestHarness', new DashboardTestHarness());

export default DashboardTestHarness